import React from 'react'
import { Menu, Icon } from 'antd'
import { FiUserPlus, FiUserMinus } from 'react-icons/fi'
import './FileActionsMenu.scss'
import { useTranslation } from 'react-i18next'

const FileActionsMenu = ({
  item,
  user,
  orgUserList,
  defaultQuery,
  userId,
  isSuperAdmin,
  isAdmin,
  aiProcessingItems,
  onAction,
  setVersionFile,
  setVersionModalVisible,
  setManagePermissionsModalVisible,
  setAuitModal,
  closeDropdown
}) => {
  const { getUserPermissions } = require('../../../utils/getPermission')
  const { isView, isEdit } = getUserPermissions(
    user,
    orgUserList,
    item,
    defaultQuery.isOrg
  )
  const canMoveOrDelete = defaultQuery.isPublic
    ? isSuperAdmin
    : isSuperAdmin || isAdmin || item.creator_id === userId

  const { t } = useTranslation()
  return (
    <Menu
      className="file-card-actions-menu"
      onClick={function(e) {
        e.domEvent.stopPropagation()
      }}
    >
      {isView && (
        <Menu.Item
          key="view"
          onClick={() => {
            onAction && onAction('view', item)
            closeDropdown && closeDropdown()
          }}
        >
          <Icon type="eye" /> {t('v3:view')}
        </Menu.Item>
      )}
      {item.media_format !== 'FOLDER' && (
        <Menu.Item
          key="download"
          onClick={() => {
            onAction && onAction('download', item)
            closeDropdown && closeDropdown()
          }}
        >
          <Icon type="download" /> {t('buttons:download')}
        </Menu.Item>
      )}
      {isEdit && (
        <Menu.Item
          key="edit"
          onClick={() => {
            onAction && onAction('edit', item)
            closeDropdown && closeDropdown()
          }}
        >
          <Icon type="edit" /> {t('v4:rename')}
        </Menu.Item>
      )}
      {canMoveOrDelete && (
        <Menu.Item
          key="copy"
          onClick={() => {
            onAction && onAction('copy', item)
            closeDropdown && closeDropdown()
          }}
        >
          <Icon type="copy" /> {t('v4:copy')}
        </Menu.Item>
      )}
      {canMoveOrDelete && (
        <Menu.Item
          key="move"
          onClick={() => {
            onAction && onAction('move', item)
            closeDropdown && closeDropdown()
          }}
        >
          <Icon type="swap" /> {t('v4:move')}
        </Menu.Item>
      )}
      {defaultQuery.isOrg &&
        item.media_format === 'APPLICATION' &&
        !item.is_ai_enabled && (
          <Menu.Item
            key="makeAi"
            disabled={aiProcessingItems.has(item.id)}
            onClick={() => {
              if (!aiProcessingItems.has(item.id) && onAction) {
                onAction('makeAi', item)
              }
              closeDropdown && closeDropdown()
            }}
          >
            <Icon type="thunderbolt" />
            {aiProcessingItems.has(item.id) ? 'Enabling AI...' : 'Enable AI'}
          </Menu.Item>
        )}
      {defaultQuery.isOrg && isView && item.media_format === 'APPLICATION' && (
        <Menu.Item
          key="version-history"
          onClick={() => {
            setVersionFile(item)
            setVersionModalVisible(true)
            closeDropdown && closeDropdown()
          }}
        >
          <Icon type="history" />
          {t('v4:verson_history')}
        </Menu.Item>
      )}
      {item.media_format === 'APPLICATION' &&
        item.media_mime_type === 'application/pdf' && (
          <Menu.Item
            key="share"
            onClick={() => {
              onAction && onAction('share', item)
              closeDropdown && closeDropdown()
            }}
          >
            <Icon type="share-alt" /> {t('v4:share')}
          </Menu.Item>
        )}
      {defaultQuery.isOrg &&
        (isSuperAdmin || isAdmin || item.creator_id === userId || isEdit) &&
        item.media_format === 'FOLDER' && (
          <Menu.Item
            key="follow-unfollow"
            onClick={() => {
              onAction && onAction('follow-unfollow', item)
              closeDropdown && closeDropdown()
            }}
          >
            {item.is_following ? (
              <FiUserMinus style={{ marginRight: 12 }} />
            ) : (
              <FiUserPlus style={{ marginRight: 12 }} />
            )}
            {item.is_following ? 'Unfollow' : 'Follow'}
          </Menu.Item>
        )}
      {defaultQuery.isOrg &&
        (isSuperAdmin || isAdmin || item.creator_id === userId) && (
          <Menu.Item
            key="manage-permission"
            onClick={() => {
              setManagePermissionsModalVisible({
                visible: true,
                id: item.id
              })
              closeDropdown && closeDropdown()
            }}
          >
            <Icon type="setting" /> {t('v4:manage_permission')}
          </Menu.Item>
        )}
      {defaultQuery.isOrg && (isAdmin || isSuperAdmin) && (
        <Menu.Item
          key="generate-audit"
          onClick={() => {
            setAuitModal({
              visible: true,
              id: item.id
            })
            closeDropdown && closeDropdown()
          }}
        >
          <Icon type="book" /> {t('v4:generate_audit_report')}
        </Menu.Item>
      )}
      <hr />
      {isEdit && (
        <Menu.Item
          key="delete"
          danger
          onClick={() => {
            onAction && onAction('delete', item)
            closeDropdown && closeDropdown()
          }}
        >
          <Icon type="delete" /> {t('v4:delete')}
        </Menu.Item>
      )}
    </Menu>
  )
}

export default FileActionsMenu
